function initSizeGuides() {
  function openModal(modal) {
    modal.classList.add('ac-sg-open');
    document.documentElement.classList.add('ac-sg-lock');
  }

  function closeModal(modal) {
    modal.classList.remove('ac-sg-open');
    if (!document.querySelector('.ac-sg-overlay.ac-sg-open')) {
      document.documentElement.classList.remove('ac-sg-lock');
    }
  }

  document.querySelectorAll('.ac-sg-trigger:not([data-sg-init])').forEach(function (btn) {
    btn.dataset.sgInit = 'true';
    btn.addEventListener('click', function () {
      const modal = document.getElementById(btn.dataset.modalId);
      if (modal) openModal(modal);
    });
  });

  if (!document.documentElement.dataset.sgEsc) {
    document.documentElement.dataset.sgEsc = 'true';
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.ac-sg-overlay.ac-sg-open').forEach(closeModal);
    });
  }

  // Row labels that belong to each block of the chart.
  const UK_ROWS = ['UK size', 'UK dress size', 'UK waist size', 'EU size'];

  function cleanLabel(label) {
    return label.replace(/^To fit\s+/i, '').replace(/^./, function (c) { return c.toUpperCase(); });
  }

  document.querySelectorAll('.ac-sg-overlay:not([data-sg-init])').forEach(function (modal) {
    modal.dataset.sgInit = 'true';

    const closeBtn = modal.querySelector('.ac-sg-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(modal);
    });

    // Shoe modals use a static table, no JS needed
    if (modal.querySelector('.ac-sg-shoe-table')) return;

    const units = modal.querySelectorAll('.ac-sg-unit');
    let currentUnit = 'inches';
    let table = modal.querySelector('.ac-sg-table');
    const wrap = modal.querySelector('.ac-sg-table-wrap');

    if (!wrap) return;

    if (!table) {
      table = document.createElement('table');
      table.className = 'ac-sg-table';
      table.dataset.sizes = '[]';
      table.dataset.measurements = '{}';
      wrap.appendChild(table);
    }

    let sizes = [];
    let measurements = {};
    try { sizes = JSON.parse(table.dataset.sizes || '[]') || []; } catch (e) {}
    try { measurements = JSON.parse(table.dataset.measurements || '{}') || {}; } catch (e) {}

    const fitRow = measurements['__fit'];
    const fitText = fitRow && fitRow.cm && fitRow.cm[0] ? fitRow.cm[0] : '';
    delete measurements['__fit'];
    const posRow = measurements['__fitpos'];
    const fitPos = posRow && posRow.cm && posRow.cm[0] ? posRow.cm[0] : '';
    delete measurements['__fitpos'];
    const gnoteRow = measurements['__gnote'];
    const gnoteText = gnoteRow && gnoteRow.cm && gnoteRow.cm[0] ? gnoteRow.cm[0] : '';
    delete measurements['__gnote'];
    const hideBody = !!measurements['__hidebody'];
    delete measurements['__hidebody'];
    const cornerRow = measurements['__corner'];
    const cornerLabel = cornerRow && cornerRow.cm && cornerRow.cm[0] ? cornerRow.cm[0] : null;
    delete measurements['__corner'];
    const hasData = sizes.length && Object.keys(measurements).length;
    const hasUk = !cornerLabel && Object.keys(measurements).some(function (k) { return UK_ROWS.indexOf(k) !== -1; });

    if (!hasData) {
      wrap.innerHTML = '<p class="ac-sg-empty">Measurements for this item are being added. Not sure which size to choose? Message us and we will help you pick the right one.</p>';
      const toggle = modal.querySelector('.ac-sg-toggle');
      if (toggle) toggle.style.display = 'none';
      ['.ac-sg-intro', '.ac-sg-subtitle', '.ac-sg-footnote'].forEach(function (sel) {
        const el = modal.querySelector(sel);
        if (el) el.style.display = 'none';
      });
      return;
    }

    if (!hasUk) {
      const intro = modal.querySelector('.ac-sg-intro');
      if (intro) intro.style.display = 'none';
    }

    function addSection(tbody, title, note, colCount) {
      const tr = document.createElement('tr');
      tr.className = 'ac-sg-section';
      const td = document.createElement('td');
      td.colSpan = colCount;
      const strong = document.createElement('span');
      strong.className = 'ac-sg-section-title';
      strong.textContent = title;
      td.appendChild(strong);
      if (note) {
        const small = document.createElement('span');
        small.className = 'ac-sg-section-note';
        small.textContent = note;
        td.appendChild(small);
      }
      tr.appendChild(td);
      tbody.appendChild(tr);
    }

    function addRow(tbody, label, values, extraClass) {
      const tr = document.createElement('tr');
      if (extraClass) tr.className = extraClass;
      const labelTd = document.createElement('th');
      labelTd.scope = 'row';
      labelTd.textContent = label;
      tr.appendChild(labelTd);
      sizes.forEach(function (_, i) {
        const td = document.createElement('td');
        td.textContent = (values[i] !== undefined && values[i] !== null && values[i] !== '') ? values[i] : '\u2014';
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    }

    // One scroller holds both boxes, so the chart slides natively as a single
    // piece: every row moves together and nothing lags or drops out. The two
    // rounded frames sit on top of it and stay put while the numbers slide.
    const host = document.createElement('div');
    host.className = 'ac-sg-host';
    if (fitText || fitPos) {
      const fitEl = document.createElement('div');
      fitEl.className = 'ac-sg-fit';
      const note = fitText.replace(/^\s*<strong>Fit:<\/strong>\s*/i, '');
      if (fitPos) {
        const pos = { small: 0, true: 1, large: 2 }[fitPos];
        const labels = ['Runs small', 'True to size', 'Runs large'];
        let html = '<div class="ac-sg-fit-title">Fit</div>' +
          '<div class="ac-sg-fit-track"><span class="ac-sg-fit-dot" style="left:' + (pos * 50) + '%"></span></div>' +
          '<div class="ac-sg-fit-labels">';
        labels.forEach(function (l, i) {
          html += '<span class="' + (i === pos ? 'is-on' : '') + '">' + l + '</span>';
        });
        html += '</div>';
        if (note) html += '<p class="ac-sg-fit-note">' + note + '</p>';
        fitEl.classList.add('ac-sg-fit--slider');
        fitEl.innerHTML = html;
      } else {
        fitEl.innerHTML = fitText;
      }
      wrap.parentNode.insertBefore(fitEl, wrap);
    }
    const hint = document.createElement('div');
    hint.className = 'ac-sg-hint';
    wrap.parentNode.insertBefore(hint, wrap);
    wrap.parentNode.insertBefore(host, wrap);
    host.appendChild(wrap);
    const frames = [0, 1].map(function () {
      const f = document.createElement('div');
      f.className = 'ac-sg-frame';
      host.appendChild(f);
      return f;
    });

    function addTitle(tbody, heading, note) {
      const tr = document.createElement('tr');
      tr.className = 'ac-sg-titlerow';
      const td = document.createElement('td');
      td.colSpan = sizes.length + 1;
      const box = document.createElement('div');
      box.className = 'ac-sg-box-title';
      const strong = document.createElement('strong');
      strong.textContent = heading;
      const span = document.createElement('span');
      span.textContent = note;
      box.appendChild(strong);
      box.appendChild(span);
      td.appendChild(box);
      tr.appendChild(td);
      tbody.appendChild(tr);
    }

    function addHead(tbody, boxId) {
      const tr = document.createElement('tr');
      tr.className = 'ac-sg-head';
      tr.dataset.box = boxId;
      const cornerTh = document.createElement('th');
      cornerTh.textContent = cornerLabel || (hasUk ? 'Select size' : 'Size');
      tr.appendChild(cornerTh);
      sizes.forEach(function (size) {
        const th = document.createElement('th');
        th.textContent = size;
        tr.appendChild(th);
      });
      tbody.appendChild(tr);
    }

    function addBoxRow(tbody, label, values, boxId, alt) {
      const tr = document.createElement('tr');
      tr.dataset.box = boxId;
      if (alt) tr.className = 'ac-sg-alt';
      const labelTd = document.createElement('th');
      labelTd.scope = 'row';
      labelTd.textContent = label;
      tr.appendChild(labelTd);
      sizes.forEach(function (_, i) {
        const td = document.createElement('td');
        td.textContent = (values[i] !== undefined && values[i] !== null && values[i] !== '') ? values[i] : '—';
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
      return tr;
    }

    function layoutFrames() {
      const hostTop = host.getBoundingClientRect().top;
      host.style.setProperty('--sg-vw', wrap.clientWidth + 'px');
      frames.forEach(function (frame, boxId) {
        const rows = table.querySelectorAll('tr[data-box="' + boxId + '"]');
        if (!rows.length || !wrap.clientWidth) { frame.style.display = 'none'; return; }
        const top = rows[0].getBoundingClientRect().top - hostTop;
        const bottom = rows[rows.length - 1].getBoundingClientRect().bottom - hostTop;
        frame.style.display = 'block';
        frame.style.top = top + 'px';
        frame.style.height = (bottom - top) + 'px';
      });
      updateHint();
    }

    const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    function updateHint() {
      const needs = wrap.scrollWidth > wrap.clientWidth + 1;
      hint.textContent = (coarse ? 'Swipe' : 'Scroll') + ' to view more sizes →';
      hint.classList.toggle('on', needs);
    }

    function buildTable(unit) {
      const unitName = unit === 'cm' ? 'cm' : 'inches';
      const groups = { uk: [], body: [], garment: [] };
      Object.keys(measurements).forEach(function (label) {
        const data = measurements[label] || {};
        const values = data[unit] || data.cm || [];
        if (UK_ROWS.indexOf(label) !== -1) groups.uk.push([label, values]);
        else if (/^To fit /i.test(label)) groups.body.push([cleanLabel(label), values]);
        else groups.garment.push([label, values]);
      });

      const bodyRows = groups.uk.concat(groups.body);
      const hasBody = bodyRows.length > 0 && !hideBody;
      const hasGarment = groups.garment.length > 0;

      table.innerHTML = '';
      const tbody = document.createElement('tbody');
      table.appendChild(tbody);

      if (hasBody) {
        addTitle(tbody, 'Find your size', 'Body measurements, in ' + unitName);
        addHead(tbody, 0);
        bodyRows.forEach(function (r, i) { addBoxRow(tbody, r[0], r[1], 0, i % 2 === 1); });
        tbody.lastChild.classList.add('ac-sg-last');
      }
      if (hasGarment) {
        if (hasBody) {
          const sp = document.createElement('tr');
          sp.className = 'ac-sg-spacer';
          const spTd = document.createElement('td');
          spTd.colSpan = sizes.length + 1;
          sp.appendChild(spTd);
          tbody.appendChild(sp);
        }
        addTitle(tbody, 'Garment measurements', (gnoteText || 'The item itself, laid flat') + ', in ' + unitName);
        addHead(tbody, 1);
        groups.garment.forEach(function (r, i) { addBoxRow(tbody, r[0], r[1], 1, i % 2 === 1); });
        tbody.lastChild.classList.add('ac-sg-last');
      }
      layoutFrames();
    }

    window.addEventListener('resize', layoutFrames);
    if (window.ResizeObserver) new ResizeObserver(layoutFrames).observe(table);
    new MutationObserver(function () { if (modal.classList.contains('ac-sg-open')) layoutFrames(); })
      .observe(modal, { attributes: true, attributeFilter: ['class'] });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layoutFrames);

    buildTable(currentUnit);

    function setUnit(unit) {
      if (unit === currentUnit) return;
      currentUnit = unit;
      units.forEach(function (u) {
        const on = u.dataset.unit === unit;
        u.classList.toggle('active', on);
        u.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      buildTable(currentUnit);
    }

    // Swipe left/right on the chart to switch units, as an alternative to the
    // INCHES / CM toggle. Only acts as a toggle when the table already fits
    // without scrolling, so a wide chart can still be scrolled sideways.
    var touchStartX = 0;
    var touchStartY = 0;

    function wrapNeedsHorizontalScroll() {
      return wrap.scrollWidth > wrap.clientWidth + 1;
    }

    wrap.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || wrapNeedsHorizontalScroll()) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      if (!touchStartX && !touchStartY) return;
      var touch = e.changedTouches[0];
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      touchStartX = 0;
      touchStartY = 0;

      if (wrapNeedsHorizontalScroll()) return;
      if (Math.abs(deltaX) < 40) return;
      if (Math.abs(deltaX) < Math.abs(deltaY)) return;

      setUnit(currentUnit === 'inches' ? 'cm' : 'inches');
    }, { passive: true });

    units.forEach(function (btn) {
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-pressed', btn.classList.contains('active') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        setUnit(btn.dataset.unit);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setUnit(btn.dataset.unit);
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initSizeGuides);
document.addEventListener('shopify:section:load', initSizeGuides);
